import { useSelector } from 'react-redux';

import { selectUser } from 'shared/selectors';

export function useUser() {
  const user = useSelector(selectUser);

  return user ?? {};
}
